import { put, call, takeLeading } from 'typed-redux-saga';
import SilverGateway from '~apis/silver';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetSilverPrices(api: SilverGateway): SagaWatcherReturnType {
    yield takeLeading('silver/silverGetSilverPricesAttempt', handleGetsilverPrices, api);
}

function* handleGetsilverPrices(api: SilverGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.getSilverPrices], {
        authToken,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.silverGetSilverPricesFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.silverGetSilverPricesSuccess(response.data));
    }
}
